import { Document, Page } from '@react-pdf/renderer'
import { Field, Objectclass, YesObject } from '@yes.technology/react-toolkit'
import locales from 'locales'
import { TranslationContainer } from 'react-i18n-lite'
import { FilterFieldsResponse } from 'shared/hooks/useFilterFields/useFilterFields'
import { FieldSettings } from 'shared/types'
import { ConcatFields } from 'shared/utils/object/concatenateFields'
import { RelationConfigProps } from 'site/Renderer/components/ObjectView/components/types/object-view'
import { GroupedFieldValues } from '../site/Renderer/components/FilterFields/types'
import ApplicationSystemTopLine from './components/ApplicationSystemTopLine'
import CardsArea from './components/CardsArea/CardsArea'
import FilterArea from './components/FilterArea/FilterArea'
import { RelationsTableLayouts } from './hooks/useRelationsTableLayouts/useRelationsTableLayouts'

interface ReportProps {
  fields?: FilterFieldsResponse
  filterComposition: string
  objectFields: Field[]
  relationClasses: Field[]
  values: GroupedFieldValues
  objects: YesObject[]
  title: string
  cardTitle: string
  objectclass?: Objectclass
  relationsTableLayouts?: RelationsTableLayouts
  filteractionName?: string
  fieldSettings?: FieldSettings
  concatFields?: ConcatFields
  relationConfig?: RelationConfigProps
  showHeader?: boolean
}

function CardsReport({
  fields,
  filterComposition,
  values,
  title,
  cardTitle,
  objects,
  objectFields,
  relationClasses,
  objectclass,
  relationsTableLayouts,
  filteractionName,
  fieldSettings,
  concatFields,
  relationConfig,
  showHeader
}: ReportProps) {
  return (
    <Document>
      <TranslationContainer locales={locales} defaultLanguage='pt-BR'>
        <Page size='A4'>
          {showHeader && (
            <>
              <ApplicationSystemTopLine />
              {fields && (
                <FilterArea
                  values={values}
                  fields={fields}
                  title={title}
                  composition={filterComposition}
                  filteractionName={filteractionName}
                />
              )}
            </>
          )}
          {objectclass && (
            <CardsArea
              title={cardTitle}
              showHeader={showHeader}
              objectclass={objectclass}
              objects={objects}
              fields={objectFields}
              relationClasses={relationClasses}
              relationsTableLayouts={relationsTableLayouts}
              fieldSettings={fieldSettings}
              concatFields={concatFields}
              relationConfig={relationConfig}
            />
          )}
        </Page>
      </TranslationContainer>
    </Document>
  )
}

export default CardsReport
